import { render, staticRenderFns } from "./cookiePolicyGold.vue?vue&type=template&id=d050f8b0"
import script from "./cookiePolicyGold.vue?vue&type=script&lang=js"
export * from "./cookiePolicyGold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports